<script setup>
import { computed, getCurrentInstance } from 'vue';
import BaseProfileDropdown from '@/layout/base/BaseProfileDropdown.vue';

const { proxy } = getCurrentInstance();
const $t = proxy.$t;

const props = defineProps({
  class: {
    type: String,
    default: ''
  },
  user: {
    type: Object,
    required: true
  }
});

// Logout function
const logout = () => {
  try {
    localStorage.removeItem('currency');
    const logoutRoute = proxy.route ? proxy.route('client.logout') : '/logout';
    proxy.$inertia.post(logoutRoute);
  } catch (error) {
    console.error('Error logging out:', error);
    proxy.$inertia.post('/logout');
  }
};

// Settings function - redirect to client profile page
const goToSettings = () => {
  try {
    const routeName = proxy.route ? proxy.route('client.profile.show') : '/profile';
    proxy.$inertia.visit(routeName);
  } catch (error) {
    console.error('Error navigating to profile:', error);
    window.location.href = '/profile';
  }
};

// Bug report function - redirect to bug report page
const goToBugReport = () => {
  try {
    const routeName = proxy.route ? proxy.route('client.bug-report') : '/bug-report';
    proxy.$inertia.visit(routeName);
  } catch (error) {
    console.error('Error navigating to bug report:', error);
    window.location.href = '/bug-report';
  }
};


// Client-specific menu items
const menuItems = computed(() => [
  {
    label: $t('Settings'),
    icon: 'pi pi-cog',
    action: goToSettings
  },
  {
    label: $t('Bug report and suggestions'),
    icon: 'pi pi-comment',
    action: goToBugReport
  },
  {
    label: $t('Log Out'),
    icon: 'pi pi-sign-out',
    action: logout
  }
]);
const userName = computed(() => {
  return ((props.user.first_name ?? '') + ' ' + (props.user.last_name ?? '')).trim() || props.user.name;
});
</script>

<template>
  <BaseProfileDropdown class="props.class" :menu-items="menuItems">
    <template #header>
      <div class="p-3 border-b text-center">
        <div class="font-medium text-sm">{{ userName }}</div>
      </div>
    </template>
  </BaseProfileDropdown>
</template>
